import React from "react"
import axios from 'axios'
import { MDCTabBar } from '@material/tab-bar';
import { MDCTextField } from '@material/textfield';
import { MDCRipple } from '@material/ripple';
import { MDCSnackbar } from '@material/snackbar';

import $ from "jquery";

var networks = [
  'telegram', "instagram", "vk", "facebook", "tiktok", "youtube"
]

function networkToHuman(network){
  if(network=="telegram") return "Telegram"
  if(network=="instagram") return "Instagram"
  if(network=="twitter") return "Twitter"
  if(network=="vk") return "ВКонтакте"
  if(network=="facebook") return "Facebook"
  if(network=="tiktok") return "TikTok"
  if(network=="youtube") return "YouTube"
}

function iconByNetwork(network){
  if(network=="telegram") return "fa-telegram-plane"
  if(network=="instagram") return "fa-instagram"
  if(network=="twitter") return "fa-twitter"
  if(network=="vk") return "fa-vk"
  if(network=="facebook") return "fa-facebook"
  if(network=="tiktok") return "fab fa-tiktok"
  if(network=="youtube") return "fab fa-youtube"
}

function iconByType(type){
  if(type=="subscribers") return "fa-user"
  if(type=="views" || type=="retweets") return "fa-eye"
  if(type=="members" || type=="friends") return "fa-user-friends"
  if(type=="reactions") return "fa-thumbs-up"
  if(type=="users") return "fa-robot"
  if(type=="likes") return "fa-heart"
  if(type=="followers") return "fa-users"
  if(type=="saves") return "fa-bookmark"
}

function statusToHuman(status){
  if(status=="created") return 'создан'
   if(status=="pending") return 'ожидает'
   if(status=="performed") return 'исполняется'
   if(status=="completed") return 'завершён'
  }
  
var types = {
  telegram: [{
    name: "Подписчики",
    type: "subscribers",
    icon: "fas fa-user"
  },
  {
    name: "Просмотры",
    type: "views",
    icon: "fas fa-eye"
  },
  {
    name: "Участники",
    type: "members",
    icon: "fas fa-user-friends"
  },
  {
    name: "Реакции",
    type: "reactions",
    icon: "fas fa-thumbs-up"
  },
  {
    name: "Пользователи",
    type: "users",
    icon: "fas fa-robot"
  }],
  instagram: [{
    name: "Подписчики",
    type: "subscribers",
    icon: "fas fa-user"
  },
  {
    name: "Лайки",
    type: "likes",
    icon: "fas fa-heart"
  },
  {
    name: "Просмотры",
    type: "views",
    icon: "fas fa-eye"
  },
  {
    name: "Сохранения",
    type: "saves",
    icon: "fas fa-bookmark"
  },
  ],
  twitter: [
    {
      name: "Фолловеры",
      type: "followers",
      icon: "fas fa-user"
    },
    {
      name: "Лайки",
      type: "likes",
      icon: "fas fa-heart"
    },
    {
      name: "Ретвиты",
      type: "retweets",
      icon: "fas fa-eye"
    },
  ],

  vk: [
    {
      name: "Друзья",
      type: "friends",
      icon: "fas fa-user-friends"
    },
    {
      name: "Участники",
      type: "subscribers",
      icon: "fas fa-user"
    },
    {
      name: "Лайки",
      type: "likes",
      icon: "fas fa-heart"
    },
    {
      name: "Репосты",
      type: "reposts",
      icon: "fas fa-retweet"
    }
  ],
  facebook: [
    {
      name: "Подписчики",
      type: "subscribers",
      icon: "fas fa-user"
    },
    {
      name: "Лайки",
      type: "likes",
      icon: "fas fa-heart"
    },
    {
      name: "Репосты",
      type: "reposts",
      icon: "fas fa-retweet"
    }
  ],
  tiktok: [
    {
      name: "Подписчики",
      type: "subscribers",
      icon: "fas fa-user"
    },
    {
      name: "Лайки",
      type: "likes",
      icon: "fas fa-heart"
    },
    {
      name: "Просмотры",
      type: "views",
      icon: "fas fa-eye"
    }
  ],
  youtube: [
    {
      name: "Подписчики",
      type: "subscribers",
      icon: "fas fa-user"
    },
    {
      name: "Лайки",
      type: "likes",
      icon: "fas fa-heart"
    },
    {
      name: "Просмотры",
      type: "views",
      icon: "fas fa-eye"
    }
  ]
}

String.prototype.flToUpperCase = function () {
  return this.toString()[0].toUpperCase() + this.toString().substr(1)
}

function insertPrefixZero(num) {
  return num < 10 ? `0${num}` : num
}

function timestampToHuman(timestamp) {
  var d = new Date(timestamp)
  return `${insertPrefixZero(d.getDate())}.${insertPrefixZero(d.getMonth() + 1)}.${insertPrefixZero(d.getFullYear())} ${insertPrefixZero(d.getHours())}:${insertPrefixZero(d.getMinutes())}`
}

function ordersLoad(orders){
  var html = ""
  orders.map(e => {
    try{
    html += `
  <tr class="mdc-data-table__row">
  <td class="mdc-data-table__cell">${e.n}</td>
  <td class="mdc-data-table__cell"><i class="fab ${iconByNetwork(e.service.network)}" aria-hidden="true" style="margin-right: 6px;font-size: 1rem;"></i>${networkToHuman(e.service.network)}</td>
  <td class="mdc-data-table__cell"><i class="fas ${iconByType(e.service.type)}" aria-hidden="true" style="margin-right: 6px;font-size: 1rem;"></i>${e.service.name }</td>
  <td class="mdc-data-table__cell">${e.link }</td>
  <td class="mdc-data-table__cell mdc-data-table__cell--numeric">${e.amount}</td>
  <td class="mdc-data-table__cell mdc-data-table__cell--numeric">${e.price}$</td>
  <td class="mdc-data-table__cell mdc-data-table__cell--numeric">${e.total}$</td>
  <td class="mdc-data-table__cell">${statusToHuman(e.status)}</td>
  <td class="mdc-data-table__cell">${e.remains}</td>
  <td class="mdc-data-table__cell">${timestampToHuman(e.timestamp)}</td>
</tr>`
    }
    catch{}})

  document.querySelector("#ordersTable").innerHTML = html

}

var services

var tabBar2

function setContent(content) {
  $('#content').animate({ 'opacity': 0 }, 100, function () {
    $('#content').html(content).animate({ 'opacity': 1 }, 100);
  });
  //document.getElementById("content").innerHTML = content
}

function getCards(services) {
  if (services.length == 0) return '<div style="align: center; width: 100%;"><h4 align="center"><br><br>Сервисы этой категории пока недоступны</h4></div>'

  return services.sort((a, b) => { return a.price - b.price }).map(service => `
 
  <div class="iboxService">
     <h3 class="item_title">${service.name}</h3>
     <div class="ibox_content" style="align-items: center; display: inline-block; vertical-align: middle; display: table-cell; ">
              <div class="item_price">${service.price}$<span class="pp"><br>${service.item}</span></div>
              <div class="idescr" style="padding-left: 4px; padding-right: 4px;">${service.descr.replace(/\n/g, "<br>")
              .replace("⌛", `<i class="fas fa-hourglass-end fa-fw" aria-hidden="true" style="color: #6200ee; font-size: 0.9rem; margin-right: 4px;"></i>`)
              .replace("⚡", `<i class="fas fa-bolt fa-fw" aria-hidden="true" style="color: #6200ee;font-size: 0.9rem; margin-right: 4px;"></i>`)
              .replace("✅", `<i class="fas fa-check fa-fw" aria-hidden="true" style="color: #6200ee;font-size: 0.9rem; margin-right: 4px;"></i>`)
              .replace("✅", `<i class="fas fa-check fa-fw" aria-hidden="true" style="color: #6200ee;font-size: 0.9rem; margin-right: 4px;"></i>`)
              .replace("✅", `<i class="fas fa-check fa-fw" aria-hidden="true" style="color: #6200ee;font-size: 0.9rem; margin-right: 4px;"></i>`)
              .replace("✅", `<i class="fas fa-check fa-fw" aria-hidden="true" style="color: #6200ee;font-size: 0.9rem; margin-right: 4px;"></i>`)
              .replace("❌", `<i class="fas fa-times fa-fw" aria-hidden="true" style="color: #6200ee;font-size: 0.9rem; margin-right: 4px;"></i>`)
              .replace("🔻", `<i class="fas fa-angle-down fa-fw" aria-hidden="true" style="color: #6200ee;font-size: 0.9rem; margin-right: 4px;"></i>`)
              .replace("🔼", `<i class="fas fa-angle-up fa-fw" aria-hidden="true" style="color: #6200ee;font-size: 0.9rem; margin-right: 4px;"></i>`)
            }</div>
            
           </div>
           <button data-toggle="modal" data-target="#exampleModal" class="mdc-button mdc-button--raised" style="border-radius: 6px; width: 309px; height: 56px; position: absolute; bottom: 10px; left: 10px;" onclick="
           document.getElementById('modalDescr').innerHTML = '${service.descr.replace(/\n/g, "<br>")}'; 
           document.getElementById('modalLabelLink').innerHTML = '${service.link}';  
            document.getElementById('modalPrice').value = '${service.price}$';  
            document.getElementById('modalTitle').innerHTML = '${service.network.flToUpperCase()} - ${service.name}';  
            document.getElementById('sidField').innerHTML = '${service.sid}';
            document.getElementById('nbg').style.height = '0%';
            document.querySelector('.success-checkmark').style.display = 'none';
            document.querySelector('.success-checkmark').style.marginTop = '0px';
            document.querySelector('.orderInfo').style.display = 'none';
            document.querySelector('.orderInfo').style.opacity = '0';
            ">
           <div class="mdc-button__ripple" style="border-radius: 6px;"></div>
           <i class="fas fa-shopping-cart" aria-hidden="true" style="color: rgb(255, 255, 255); margin-right: 8px;"></i><span class="mdc-button__label">Заказать</span>
        </button>

  </div>

    
    `).join("")
}

function setTypeTabBar(network, test) {
  console.log('setTypeTabBar', network, test)
  var content = types[network].map(e => {
    return `
    <button class="mdc-tab" role="tab" aria-selected="true" tabindex="0">
                <span class="mdc-tab__content">
                  <span class="mdc-tab__icon" aria-hidden="false"><i class="${e.icon} fa-fw"></i></span>
                  <span class="mdc-tab__text-label">&nbsp; ${e.name}</span>
                </span>
                <span class="mdc-tab-indicator">
                  <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                </span>
                <span class="mdc-tab__ripple"></span>
              </button>
    `
  }).join("").replace("mdc-tab-indicator", "mdc-tab-indicator mdc-tab-indicator--active").replace("mdc-tab", "mdc-tab mdc-tab--active")

  $('#types').animate({ 'opacity': 0 }, 100, function () {
    $(this).html(content).animate({ 'opacity': 1 }, 100);
  });
  setTimeout(() => {
    try {
      tabBar2 = new MDCTabBar(document.getElementById('tab2'));

      tabBar2.listen('MDCTabBar:activated', function (event) {
        tab2id = event.detail.index
        console.log(networks[tab1id])
        console.log(types[networks[tab1id]][tab2id].type)
        console.log(services.filter(e => e.network == networks[tab1id]))
        setContent(getCards(services.filter(e => e.network == networks[tab1id] && e.type == types[networks[tab1id]][tab2id].type)));

      })
      tabBar2.focusOnActivate = false
    }
    catch (e) { console.log(e) }
  }, 210)

}

const MainTabElement = (props) => {
  return <button className={props.active == "true" ? "mdc-tab mdc-tab--active" : "mdc-tab"} role="tab" aria-selected="false" tabindex="-1">
    <span className="mdc-tab__content">
      <span className="mdc-tab__icon" aria-hidden="true"><i className={"fab " + props.icon}></i> </span>
      <span className="mdc-tab__text-label">{props.label}</span>
    </span>
    <span className={props.active == "true" ? "mdc-tab-indicator mdc-tab-indicator--active" : "mdc-tab-indicator"}>
      <span className="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
    </span>
    <span className="mdc-tab__ripple"></span>
  </button>
}

var tab1id = 0, tab2id = 0
if(window.location.hash.replace('#', '').length != 0)
  tab1id = ['telegram', 'instagram', 'vk', 'facebook', 'tiktok', 'youtube'].indexOf(window.location.hash.replace('#', ''))

function orderModalInit() {



  const orderBtn = new MDCRipple(document.querySelector('#orderBtn'));
  const urlField = new MDCTextField(document.querySelector('#urlField'));
  const colField = new MDCTextField(document.querySelector('#colField'));
  const colInput = document.querySelector('#colInput')
  const priceField = new MDCTextField(document.querySelector('#priceField'));
  const totalField = new MDCTextField(document.querySelector('#totalField'));
  const totalInput = document.querySelector('#totalInput')

  document.querySelector('#orderBtn').addEventListener('click', () => {
    
    var link = document.querySelector('#linkInput').value, 
      amount = Number(document.querySelector('#colInput').value),
      total = Number(document.querySelector('#totalInput').value),
      sid = Number(document.querySelector('#sidField').innerHTML)

    if (!link) return snackbar.openText("Введите ссылку") 
    if (!amount) return snackbar.openText("Введите количество")
 
    axios.get(`https://nakrutkatop.com:443/api/boost/order?sid=${sid}&amount=${amount}&link=${link}&total=${encodeURI(total)}`, { withCredentials: true })
      .then(res => {
        if (!res.data.ok) return snackbar.openText(res.data.descr)
        document.querySelector('#oiOID').innerHTML =  res.data.oid.toFixed(2)
        document.querySelector('#oiTotal').innerHTML = res.data.total.toFixed(2) + "$"
        document.querySelector('#oiBalance').innerHTML = res.data.balance.toFixed(2) + "$"

        $(".check-icon").hide(); 
        $("#nbg").css("height", "100%"); 
        $(".success-checkmark").css("display", "block")
        $(".success-checkmark").css("opacity", "1"); 
        $(".orderInfo").css("display", "block");
    
        setTimeout(function () { $(".check-icon").show()}, 900)
        setTimeout(function () {
           $(".orderInfo").css("opacity", "1");
           $(".success-checkmark").css("margin-top", "-200px");   }, 2000)

           setTimeout(function () {
            $('#oiBalance').animate({ 'opacity': 0 }, 150, function () {
              $(this).html((res.data.balance - res.data.total) + "$").animate({ 'opacity': 1 }, 150);
            });
             }, 3833)
 
      
/*
 id="oiOID">157<
"oiTotal">10$</t
" id="oiBalance"
        snackbar.openText(res.data.descr)
        setTimeout(() => {

          $('#exampleModal').removeClass('show');
          $('#exampleModal').css("display", "none")

          $('.modal-backdrop').remove();
          $('body').removeClass('modal-open');
        }, 1500)*/
      }
      )
  });

  const snackbar = new MDCSnackbar(document.querySelector('.mdc-snackbar'));
  snackbar.openText = function (text) {
    document.querySelector("#modalSnackbar").innerHTML = text
    snackbar.open()
  }
  colInput.oninput = function () {
    document.querySelector('#totalField').classList.add("mdc-text-field--label-floating")
    document.querySelector('#totalLabel').classList.add("mdc-floating-label--float-above")
    totalInput.value = (Number(colInput.value) * Number(document.querySelector('#modalPrice').value.replace("$", ""))).toFixed(2)
  }

  totalInput.oninput = function () {
    document.querySelector('#colField').classList.add("mdc-text-field--label-floating")
    document.querySelector('#colLabel').classList.add("mdc-floating-label--float-above")
    colInput.value = (Number(totalInput.value) / Number(document.querySelector('#modalPrice').value.replace("$", ""))).toFixed(2)
  }
}

class BoostPage extends React.Component {

  componentDidMount() {
   /* document.getElementById("block2").style.backgroundColor = "#6200ee";
    document.getElementById("block2").classList.add("mactb");
    document.getElementById("li2").classList.add("mactl");
    document.getElementById("li2").style.backgroundColor = "#1B1D1E";
*/
    const mainTabBar = new MDCTabBar(document.querySelector('#maintab'));
    mainTabBar.listen('MDCTabBar:activated', function (event) {
      var id = event.detail.index
      if (id == 0) {
        $('#myOrdersContent').css("opacity", "1").animate({ 'opacity': 0 }, 100, function () {
          $('#myOrdersContent').css("display", "none")
          $("#newOrderContent").css("opacity", "0").css("display", "block").animate({ 'opacity': 1 }, 100);
        })
      }
      else {
        $('#newOrderContent').css("opacity", "1").animate({ 'opacity': 0 }, 100, function () {
          $('#newOrderContent').css("display", "none")
          $("#myOrdersContent").css("opacity", "0").css("display", "block").animate({ 'opacity': 1 }, 100);
        })
      }
    })

    const tabBar = new MDCTabBar(document.querySelector('#tab1'));
    tabBar.listen('MDCTabBar:activated', function (event) {
      tab1id = event.detail.index
      console.log('activated')
      setTypeTabBar(networks[tab1id])
      setContent(getCards(services.filter(e => e.network == networks[tab1id] && e.type == types[networks[tab1id]][0].type)))

    })

    axios.get("https://nakrutkatop.com:443/api/boost/services", { withCredentials: true })
      .then(res => {

        services = res.data.services

        console.log(window.location.hash.replace('#', ''))
        if(window.location.hash.replace('#', '').length != 0)
            setTypeTabBar(window.location.hash.replace('#', ''), 2)
        else setTypeTabBar("telegram", 1)
        setContent(getCards(services.filter(e => e.network == networks[tab1id] && e.type == types[networks[tab1id]][0].type)))
        console.log(services.filter(e => e.network == networks[tab1id] && e.type == types[networks[tab1id]][0].type))

        orderModalInit()
        ordersLoad(res.data.orders)

        setTimeout(() => {
          try {
            document.getElementById("boostPageContent").style.opacity = 1
            document.getElementById("boostPageContent").style.visibility = "visible"
          }
          catch { }
        }, 150)
      })

  }

  render(props) {
    console.log(props)
    return <div className="mdc-drawer-app-content mdc-top-app-bar--fixed-adjust" style={{opacity: "0", visibility: "hidden", transition: ".3s opacity, .3s visibility" }} id="boostPageContent">

      <div className="mdc-tab-bar" role="tablist" id="maintab" style={{marginBottom: '16px'}}>
        <div className="mdc-tab-scroller">
          <div className="mdc-tab-scroller__scroll-area">
            <div className="mdc-tab-scroller__scroll-content">
              <button className="mdc-tab mdc-tab--active" role="tab" aria-selected="false" tabindex="-1">
                <span className="mdc-tab__content">
                  <span className="mdc-tab__icon" aria-hidden="true"><i className="fas fa-plus"></i> </span>
                  <span className="mdc-tab__text-label">Новый заказ</span>
                </span>
                <span className="mdc-tab-indicator mdc-tab-indicator--active">
                  <span className="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                </span>
                <span className="mdc-tab__ripple"></span>
              </button>
              <button className="mdc-tab" role="tab" aria-selected="false" tabindex="-1">
                <span className="mdc-tab__content">
                  <span className="mdc-tab__icon" aria-hidden="true"><i className="fas fa-shopping-cart"></i> </span>
                  <span className="mdc-tab__text-label">Мои заказы</span>
                </span>
                <span className="mdc-tab-indicator">
                  <span className="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                </span>
                <span className="mdc-tab__ripple"></span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div id="newOrderContent" >
        <div className="mdc-tab-bar" role="tablist" id="tab1" style={{marginBottom: '16px'}}>
          <div className="mdc-tab-scroller">
            <div className="mdc-tab-scroller__scroll-area">
              <div className="mdc-tab-scroller__scroll-content">
                <MainTabElement active={tab1id == 0 ? "true": "false"} label="Telegram" icon="fa-telegram-plane" />
                <MainTabElement active={tab1id == 1 ? "true": "false"} label="Instagram" icon="fa-instagram" />
                <MainTabElement active={tab1id == 2 ? "true": "false"} label="ВКонтакте" icon="fa-vk" />
                <MainTabElement active={tab1id == 3 ? "true": "false"} label="Facebook" icon="fa-facebook" />
                <MainTabElement active={tab1id == 4 ? "true": "false"} label="TikTok" icon="fab fa-tiktok" />
                <MainTabElement active={tab1id == 5 ? "true": "false"} label="YouTube" icon="fab fa-youtube" />
              </div>
            </div>
          </div>
        </div>

        <div className="mdc-tab-bar" role="tablist" id="tab2">
          <div className="mdc-tab-scroller">
            <div className="mdc-tab-scroller__scroll-area">
              <div className="mdc-tab-scroller__scroll-content" id="types">

              </div>
            </div>
          </div>
        </div>

        <div id="generic_price_table">
          <div className="container" style={{ marginTop: "-5px", paddingLeft: "15px", paddingRight: "15px" }}>
            <div className="row" id="content" style={{ justifyContent: "center" }}>
              Сервисы этой категории пока недоступны
            </div>

          </div>
        </div>
      </div>

      <div id="myOrdersContent" style={{display: "none", opacity: "0", overflow: "auto"}}>
        <div class="mdc-data-table" style={{ width: "100%" }}>
          <table class="mdc-data-table__table" aria-label="Dessert calories">
            <thead>
              <tr class="mdc-data-table__header-row">
                <th class="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments"><b>ID заказа</b></th>
                <th class="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments"><b>Соц. сеть</b></th>
                <th class="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments"><b>Сервис</b></th>
                <th class="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments"><b>Ссылка</b></th>
                <th class="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments"><b>Количество</b></th>
                <th class="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments"><b>Цена</b></th>
                <th class="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments"><b>Сумма</b></th>
                <th class="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments"><b>Статус</b></th>
                <th class="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments"><b>Осталось</b></th>
                <th class="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments"><b>Дата и время</b></th>
              </tr>
            </thead>
            <tbody class="mdc-data-table__content" id="ordersTable">

            </tbody>
          </table>
        </div>
      </div>

    </div>
  }
}

export default BoostPage